import React from "react";
import { AuditContextValue } from "./audit.types";

export const AuditContext = React.createContext<AuditContextValue>({} as AuditContextValue);
